import { Label, TagPicker } from '@fluentui/react';
import React, { Fragment, useMemo } from 'react';

const PickerYear = (props) => {

    const {
        label,
        pickerProps = {},
        years = []
    } = props;
    const { disabled, onChange, required } = pickerProps;

    const styles = useMemo(
        () => {
            return {
                label: {
                    root: {
                        color: disabled ? "#D9D9D9" : "black",
                        fontWeight: disabled ? 700 : 400,
                        fontSize: 14,
                        lineHeight: "18px",
                        paddingBottom: 3,
                        textTransform: "uppercase"
                    },
                },
                text: {
                    background: disabled ? "#FAFAFA !important" : "white !important",
                    border: disabled ? "1px solid #DBDBDB !important" : "1px solid black !important",
                    borderRadius: 3,
                    selectors: { "::after": { background: "transparent" } }
                },
            };
        },
        [disabled]
    );

    const onInputChange = (input) => {

        // Annuler la saisie si 5 dates sont d�j� renseign�es
        if (years.length === 5) return " ";

        input = input.trim();

        if (input.length >= 4) {
            if (input.length === 4) {
                input = parseInt(input);
                if (Number.isInteger(Number(input)) && input >= 1900 && input <= new Date().getFullYear()) {
                    const newYears = [...years, input];
                    onChange(newYears);
                }
            }
            input = " "; // Espace ; bypass un bug de FluentUI qui ne rerender pas correctement l'input s'il est vide
        }

        return input;
    };

    return <Fragment>
        <Label required={required} disabled={disabled} styles={styles.label}>{label}</Label>
        <TagPicker
            {...pickerProps}
            inputProps={{ placeholder: "-" }}
            onChange={items => onChange(items.map(item => item.key))}
            onInputChange={onInputChange}
            onResolveSuggestions={(filter, selectedItems) => []}
            selectedItems={years.filter(year => !!year).map(year => ({ key: year, name: year }))}
            styles={styles}
        />
    </Fragment>;

};

export default PickerYear;